<template>
    <div class="main" id="main-wrapper">
        <el-container class="ppl-wrapper">
            <el-header>
                <KdHeader @getToggle="toggleBtnClick"></kdHeader>
            </el-header>
            <el-container class="ppl-container">
                <el-aside width="100px">
                    <KdSidemenu :isCollapse="isCollapse" :menuData="menuData"></KdSidemenu>
                </el-aside>
                <el-main class="map-no-padding" id="main">
                    <div class="" style="height: 40px;min-height: 40px;" v-if="showBread"></div>
                    <el-header class="breadcrumb-header" style="height: 40px;min-height: 40px;" v-if="showBread">
                        <span style="float:left;font-family: PingFangSC-Regular;font-size: 12px;color: #575A5F;letter-spacing: 0;">您的当前位置：</span>
                        <el-breadcrumb
                                style="float:left;font-family: PingFangSC-Regular;font-size: 12px;color: #8C9097;letter-spacing: 0;"
                                separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item v-for="(item, index) in getTitleList" :key="index" :value="item.name"
                                                :to="item.route">{{ item.name}}
                            </el-breadcrumb-item>

                        </el-breadcrumb>
                    </el-header>
                    <div class="line"></div>
                    <router-view :key="key"></router-view>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
	import KdSidemenu from 'components/kd-sidemenu';
	import KdHeader from 'components/kd-header';
	// import {getMenuList} from 'main/service/menu';
	import {mapGetters} from 'vuex';

	export default {
		name: 'ppl-home',
		components: {
			KdHeader,
			KdSidemenu
		},
		data() {
			return {
				menuData: {
					menus: []
				},
				isCollapse: false,
				isMap: true,
				titleList: [],
				showBread: false
			};
		},
		computed: {
			...mapGetters([
				'getTitleList'
			]),
			key() {
				this.getTitle();
				console.log(this.$route.name);
				return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date();
			}
		},
		mounted() {
			let winWidth = document.body.clientWidth || document.documentElement.clientWidth;
			if (winWidth <= 1440) {
				this.isCollapse = true;
				this.kdSlideMenuIsCollapse();// 菜单是否折叠 vuex
				document.getElementsByClassName('kd-sidemenu')[0].classList.add('nav-hide');
			}
			// document.getElementById('main').addEventListener('scroll', this.handleScroll);
			// 面包屑横向滚动监听改变left位置
			window.addEventListener('scroll', this.scorllHorizontal);
		},
		created() {
			this.menuData.menus = sessionStorage.getItem('auth_menu_array') ? JSON.parse(sessionStorage.getItem('auth_menu_array')) : [];
		},
		methods: {
			// 处理滚动条距离
			// handleScroll() {
			// 	let scrollTop = document.getElementById('main').scrollTop;
			// 	this.$store.commit('updateScrollTop', scrollTop);
			// },
			handleChange(page) {
				if (page === 'ppl-logout') {
					this.$store.commit('logout', this);
					this.$router.push({
						name: 'login'
					});
				} else {
					this.$router.push({
						name: page
					});
				}
				;
			},
			toggleBtnClick(msg) {
				this.isCollapse = msg.isCollapse;
				if (this.isCollapse) {
					document.getElementsByClassName('kd-sidemenu')[0].classList.add('nav-hide');
				} else {
					document.getElementsByClassName('kd-sidemenu')[0].classList.remove('nav-hide');
				}
				this.kdSlideMenuIsCollapse();// 菜单是否折叠 vuex
			},
			getTitle() {
				if (sessionStorage.getItem('titleList') !== undefined || sessionStorage.getItem('titleList') !== null) {
					switch (this.$route.name) {
						case 'map-index':
							this.$store.dispatch('setTitle', [{name: '小程序管理', route: ''}]);
							this.showBread = true;
							break;
						case 'project-detail':
							this.$store.dispatch('setTitle', [{
								name: '小程序管理',
								route: '/icmp'
							}, {name: '小程序项目详情', route: ''}]);
							this.showBread = true;
							break;
						case 'official-account-manage':
							this.$store.dispatch('setTitle', [{name: '公众号管理', route: ''}]);
							this.showBread = true;
							break;
						case 'official-account-detail':
							this.$store.dispatch('setTitle', [{
								name: '公众号管理',
								route: '/official-account-manage'
							}, {name: '公众号项目详情', route: ''}]);
							this.showBread = true;
							break;
						case 'open-platform-manage':
							this.$store.dispatch('setTitle', [{name: '开放平台管理', route: ''}]);
							this.showBread = true;
							break;
						case 'customer-manage':
							this.$store.dispatch('setTitle', [{name: '客户管理', route: ''}]);
							this.showBread = true;
							break;
						default:
							this.showBread = false;
							break;
					}
				}
				else {
					this.titleList = sessionStorage.getItem('titleList');
				}
			},
			// 面包屑横向滚动监听改变left位置
			scorllHorizontal(width) {
				let fixedDom = document.getElementsByClassName('breadcrumb-header')[0];
				let scrollLeft = document.getElementsByTagName('html')[0].scrollLeft;
				let menuWidth = this.isCollapse ? 38 : 180;
				if (!fixedDom) {
					return;
				}
				fixedDom.style.left = menuWidth - scrollLeft + 'px';
				fixedDom.style.width = document.documentElement.clientWidth;
			},
			// 菜单是否折叠 vuex
			kdSlideMenuIsCollapse() {
				this.$store.dispatch('setIsCollapse', this.isCollapse);
			}
		},
		watch: {
			isCollapse: function (newVal, oldVal) {
				this.scorllHorizontal(newVal ? 38 : 180);
			}
		}
	};
</script>

<style lang="scss">
    .main {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .line {
        width: 100%;
        height: 0px;
        background: #DEE2EE;
    }

    .ppl-wrapper {
        & > .el-header {
            padding: 0;
            height: 60px !important;
        }
    }

    .ppl-container {
        position: absolute;
        width: 100%;
        top: 60px;
        bottom: 0;
        & > .el-main {
            position: relative;
			background-color: #f0f4fc;
        }
        & > .el-aside {
			padding-top: 46px;
			background-color: #fff;
			border-right: 1px solid #c3cad9;
            overflow: inherit;
        }
        .map-no-padding {
            padding: 0;
        }
    }

    .nav-hide .el-submenu__icon-arrow {
        display: none;
    }

    .breadcrumb-header {
        position: fixed;
        top: 50px;
        width: 100%;
		padding: 20px 20px 0px 20px;
        z-index: 1000;
    }
</style>



// WEBPACK FOOTER //
// main/view/main/Main.vue